import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8.32593 7.33398H20.3259",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.32593 12.334H20.3259",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.32593 17.334H20.3259",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.67407 7.33398H5.67407",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.67407 12.334H5.67407",
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.67407 17.334H5.67407",
				stroke: "#2B313A",
				strokeWidth: 1.5
			})
		]
	})
});
export default SvgListIcon;
